<template>
  <div>
    <div class="ls_drawer_main_content">
      <h1 class="item_detail_header">
        Смена #{{ detail.number }}
        <Tag v-if="!detail.close_date" color="green">Открыта</Tag>
        <Tag v-else color="orange">Закрыта</Tag>
      </h1>

      <!-- STORE -->
      <Row>
        <Col span="12">
          Магазин:
        </Col>
        <Col span="12">
          <router-link
            v-if="display_store_link"
            :to="{
              name: 'store_detail',
              params: { id: detail.store }
            }"
            ><b>{{ detail.store_display }}</b></router-link
          >
          <span v-else>
            <b>{{ detail.store_display }}</b>
          </span>
        </Col>
      </Row>

      <!-- CASH-->
      <Row>
        <Col span="12">
          Касса:
        </Col>
        <Col span="12">
          <router-link
            v-if="display_cash_link"
            :to="{
              name: 'cash_detail',
              params: { id: detail.cash }
            }"
          ><b>{{ detail.cash_display }}</b></router-link
          >
          <span v-else>
            <b>{{ detail.cash_display }}</b>
          </span>
        </Col>
      </Row>

      <!-- CASHIER-->
      <Row>
        <Col span="12">
          Кассир:
        </Col>
        <Col span="12">
          {{ detail.cashier_display }}
        </Col>
      </Row>

      <!-- OPEN DATE -->
      <Row>
        <Col span="12">
          Дата открытия:
        </Col>
        <Col span="12">
          {{ formatDateTime(detail.open_date) }}
        </Col>
      </Row>

      <!-- CLOSE DATE -->
      <Row v-if="detail.close_date">
        <Col span="12">
          Дата закрытия:
        </Col>
        <Col span="12">
          {{ formatDateTime(detail.close_date) }}
        </Col>
      </Row>

      <!-- RECENT OPERATIONS -->
      <div style="text-align: center;">
        <RadioGroup v-model="doc_tab_switch" type="button">
          <Radio :label="doc_tab_switch_labels[0]"></Radio>
          <Radio :label="doc_tab_switch_labels[1]"></Radio>
        </RadioGroup>
      </div>

      <recentProductOrders
        v-if="doc_tab_switch === doc_tab_switch_labels[0]"
        style="min-height: 20%; margin-top: 20px"
        filter_by="shift"
        :filter_by_id="id"
      ></recentProductOrders>

      <recentMoneyOrders
        v-else
        style="min-height: 20%; margin-top: 20px"
        filter_by="shift"
        :filter_by_id="id"
      ></recentMoneyOrders>
    </div>
    <div class="ls_drawer_footer">
      <Button style="margin-right: 8px" @click="cancelAction()">Отмена</Button>
      <!--<Button v-if="display_edit_button" type="primary" @click="editAction()">Редактировать</Button>-->
      <!--<Button v-if="display_delete_button" type="error" @click="deleteAction()" style="float: left"-->
      <!--&gt;Удалить-->
      <!--</Button>-->
    </div>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
import {
  formatNumber,
  formatDate,
  formatDateTime
} from "../../base/base_func.js";
import { BaseDetailData } from "../../base/base_detail.js";
import recentProductOrders from "../../components/core/recentProductOrders";
import recentMoneyOrders from "../../components/core/recentMoneyOrders";

let _app = BaseDetailData();
_app.data = function() {
  return {
    loading: true,
    detail: {},

    //  Additional nested data
    sections: [],
    showAddSectionModal: false,
    formSectionData: {
      name: ""
    },

    doc_tab_switch: "Движение товара",
    doc_tab_switch_labels: ["Движение товара", "Движение денег"]
  };
};
_app.components = {
  recentProductOrders,
  recentMoneyOrders
};

// _app.methods.editAction = function() {
//   this.$router.push({
//     name: this.item_type + "_edit",
//     params: { id: this.id }
//   });
// };
export default _app;
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/apps/shift/shiftDetail.vue